<template>
  <m-contents-wrapper content-type="post" :pause-if-category-not-found="pauseIfCategoryNotFound"
                      :content-type="contentType" :content-category="contentCategory">
    <template slot-scope="{ contents,imageHandler }">

      <swiper id="postsSlider300" class="w-100" ref="mySwiper" :options="swiperOptions">

        <swiper-slide v-for="content in contents" :key="content.id" class=" ">

          <b-col class="text-center">
            <m-c3 class="postsSlider300-card">
              <template #p1>
                <m-a
                    class="text-dark"
                    :href="{
                        name: setRouteName,
                        params: { slug: content.slug },
                      }"
                >
                  <m-img
                      :alt="content.title"
                      :src="content.thumbnail"
                      class="img-fluid "
                      style="height: 190px"
                  />
                </m-a>
              </template>
              <template #p2>
                <m-h5 class="py-3">
                  <m-a
                      class="text-dark"
                      :href="{
                          name: setRouteName,
                          params: { slug: content.slug },
                        }"
                  >
                    {{ content.title }}
                  </m-a>
                </m-h5>
                <p v-html="content.abstraction"/>
              </template>
            </m-c3>
          </b-col>

        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>


    </template>
  </m-contents-wrapper>
</template>

<script>
import {directive, Swiper, SwiperSlide} from "vue-awesome-swiper";

export default {
  name: "PostsSlider300",
  props: {
    contentCategory: {
      default: () => {
        return null
      }
    },
    contentType: {
      default: 'post',
      validator(value) {
        // The value must match one of these strings
        return ['post', 'page'].includes(value)
      }
    },
    pauseIfCategoryNotFound: {
      default: true,
    },
  },
  computed: {
    setRouteName() {
      if (this.contentType === 'post') {
        return 'SinglePost'
      }
      return 'SinglePage'
    }
  },
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        autoplay: {
          delay: 2000,
        },
        breakpoints: {
          300: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,

          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>

<style>
#postsSlider300:hover > .swiper-wrapper .swiper-slide div a button {
  background-color: var(--primary) !important;
  color: var(--light) !important;
  transition-duration: 0.4s;
  height: 50px;
  border: none !important;
}

/* slider buttons */
#postsSlider300 .swiper-button-next, #postsSlider300 .swiper-button-prev {
  color: var(--secondary) !important;
}

#postsSlider300 .swiper-pagination-bullet, #postsSlider300 .swiper-pagination-bullet-active, #postsSlider300 .swiper-pagination-bullet-active-main {
  color: var(--primary) !important;
  background: var(--primary) !important;
}

/* slider buttons */
</style>

<style scoped>
.image-size {
  width: 192px;
  height: 192px;
  object-fit: cover;
}

</style>
